import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=2774dbb7&"
import script from "./Customizer.vue?vue&type=script&lang=js&"
export * from "./Customizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports